export enum PARTNER {
  skymark = 'V1',
  guep = 'j9',
}

export type RiskAddressModel = {
  city: string;
  complement: string;
  neighborhood: string;
  number: string;
  state: string;
  street: string;
  zipCode: string;
};

export type RiskCnhModel = {
  category: string;
  stateEmission: string;
  dateFirstLicense: string;
  registrationNumber: string;
  securityNumber: string;
  expirationDate: string;
};

export type RiskTruckerModel = {
  personId?: string;
  truckerIsActive: boolean;
  address: RiskAddressModel;
  cellPhone: string;
  isDriverPhone: boolean;
  cnh: RiskCnhModel;
  cpf: string;
  fatherName: string;
  isRegistered: boolean;
  isSelfValid: boolean;
  motherName: string;
  birthday: string;
  name: string;
  profileId: string;
  riskId: string;
  type: string;
};

export type RiskTruckCompositionOwnerModel = {
  address: RiskAddressModel;
  cellPhone: string;
  cpfCnpj: string;
  name: string;
  motherName: string;
  birthdate: string;
  rntrc: string;
  rntrcUuid: string;
  rntrcCpfCnpj: string;
  rntrcName: string;
  rntrcUuid: string;
  rntrcOwnerIsTruckOwner: boolean;
};

export type RiskTruckCompositionRNTRCModel = {
  rntrc: string;
  rntrcUuid: string;
  rntrcCpfCnpj: string;
  rntrcName: string;
};

export type RiskTruckCompositionModel = {
  uuid?: string;
  brand: string;
  chassis: string;
  plateApi: boolean;
  city: string;
  color: string;
  leaserCpfCnpj: string;
  leaserName: string;
  model: string;
  modelYear: string;
  monofactureYear: string;
  plate: string;
  renavam: string;
  state: string;
  truckerIsOwner: boolean;
  typeId: string;
  typeName: string;
  vehicleIsLeased: boolean;
  owner: RiskTruckCompositionOwnerModel;
};

export type RiskTruckModel = {
  typeName: string;
  typeId: string;
  compositions: RiskTruckCompositionModel[];
};

export type RiskTravelModel = {
  originCity: string;
  originState: string;
  destinationCity: string;
  destinationState: string;
  cargoType: string;
  cargoValue: string;
  freightId?: string;
};

export type RiskModel = {
  uuid?: string;
  trucker: RiskTruckerModel;
  truck: RiskTruckModel;
  travel: RiskTravelModel;
  partnerId: PARTNER;
};
